<h3>Habilitar MCC para Pessoa Física</h3>
<div fxLayout="row" fxLayoutAlign="left stretch">
  <div fxLayoutGap="20px" class="filter-container" *ngIf="hasWriteAccess">
    <div fxFlex="10" fxFlexAlign="center">
      <button class="fd-button" (click)="addMcc()" >
        <div class="d-flex  justify-content-center">
          <fa-icon icon='plus-circle' size="1x"></fa-icon> Novo registro
        </div>
      </button>
    </div>
  </div>
</div>

<form [formGroup]="formGroup">
  <div fxLayout="row" fxLayoutAlign="left stretch">
    <div fxLayoutGap="20px" class="filter-container">
      <div fxFlex="33">
        <fd-institution (institutionSelected)="changeSelectedInstitution($event)" [formGroup]="formGroup"
                        [field]="fields.institution">
        </fd-institution>
      </div>
      <div fxFlex="33">
        <fd-service-contract [formGroup]="formGroup" [field]="fields.serviceContract"
        [institution]="selectedInstitution">
        </fd-service-contract>
      </div>
      <div fxFlex="10" fxFlexAlign="center">
        <fd-button  mat-flat-button [content]="'Buscar'" 
        (trigger)="search()"  
        ></fd-button>
      
      </div>
    </div>
  </div>
</form>
   <div class='list'>
  <div class="table-list__filter-input">
    <fd-input
      [parentForm]="formGroup"
      [field]="fields.mccFilter"
      fxFlex=30 >
    </fd-input>
  </div>
  
  <app-list-mcc
      [dataSource]="dataSource"
      [totalItens]="totalItens"
      (deleteItem)="deleteMcc($event)"
      (itemDetails)="itemDetails($event)"
      (changePage)="changePage($event)">
  </app-list-mcc>
  </div>